import { Navigate, Route, Routes } from 'react-router-dom'
import InvestigationPage from './pages/InvestigationPage'

const InvestigationRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<InvestigationPage />} />
      <Route path="*" element={<Navigate to="/investigation" replace />} />
    </Routes>
  )
}

export default InvestigationRoutes
